import axios from '../localAxios';
import { Workspace } from './types';
import { workspaceIdURL } from './workspacesURLs';
interface DeleteWorkspaceParams {
  workspaceId: string;
}

export async function deleteWorkspace({ workspaceId }: DeleteWorkspaceParams) {
  const url = workspaceIdURL(workspaceId);
  const { data } = await axios.delete<Workspace>(url.href);
  return data;
}
